import authService from './services/authService';

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

export const publicRequest = authService.createAxiosInstance();

export const userRequest = authService.createAxiosInstance();

// Legacy function for backward compatibility
export const updateAuthToken = (token) => {
    console.warn('updateAuthToken is deprecated. Use authService instead.');
};